export enum PaymentTypeList {
    DeliveryAndOrder = "delivery-order",
    Free = "free",
  }
  
  